export default __webpack_public_path__ + "static/media/expBlack.777d4bba.svg";